module.exports = __webpack_public_path__ + "static/virksomheder-ec5b0fd943dcb3a82009da2c9a3c2872.webm";